import { SearchTermCriteria } from '../../../components/chatWidget/types'

export const targetedSearchTerms: SearchTermCriteria[] = []
